module.exports = __webpack_public_path__ + "info-icon.14b44daf61ebb7bbf8857c9ef67771a7.svg";